<template>
    <div>
        <el-dialog title="产品详情"  v-model="dialogFormVisible" width="90%" top="5%">
            <el-form ref="formProduct" :model="formProduct" :rules="formProductRules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="大类名：" prop="productDetail_mtype" :label-width="formLabelWidth">
                            {{formProduct.productDetail_mtype}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="小类名：" prop="productDetail_stype" :label-width="formLabelWidth">
                            {{formProduct.productDetail_stype}}
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="产品名称：" prop="productDetail_name" :label-width="formLabelWidth">
                            {{formProduct.productDetail_name}}
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24">
                        <el-form-item label="产品图片" prop="attchs" :label-width="formLabelWidth">
                                <span v-for="( item, index ) in formProduct.attchs" :key="item">
                                    <el-image v-if="item" style="width: 800px; height: 100px" :src="this.tempPicUrl[index]" class="avatar" />
                                </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注：" prop="productDetail_Remark" :label-width="formLabelWidth" style="text-align: left;">
                            <div>{{formProduct.productDetail_Remark}}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-tabs
                    v-model="formProduct.productDetail_typeNumberName"
                    type="border-card"
                    class="demo-tabs1"
                >
                    <el-tab-pane label="属性一" :name=0>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="官能度:" prop="productDetail_functionality" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_functionality}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="APHA No. (max.):" prop="productDetail_APHANO" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_APHANO}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="羟值 (mgKOH/g):" prop="productDetail_hydroxyl_value" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_hydroxyl_value}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="分子量 (Avg.):" prop="productDetail_MW" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_MW}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="水份 (%, max.):" prop="productDetail_watercontent" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_watercontent}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="粘度 (cps,25℃):" prop="productDetail_vicosity" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_vicosity}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="钾&钠离子 (ppm,max.):" prop="productDetail_NaK" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_NaK}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="固含量 (%, avg.):" prop="ProductDetail_Solid" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.ProductDetail_Solid}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="应用:" prop="productDetail_Application" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_Application}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="CP:" prop="productDetail_CP" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_CP}}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性二" :name=1>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="属性名：" prop="productDetail_Properties" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_Properties}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="单位：" prop="productDetail_Unit" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_Unit}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售规格：" prop="productDetail_sales_specification" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_sales_specification}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="典型值：" prop="productDetail_typical_value" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_typical_value}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="测试方法：" prop="productDetail_test_method" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_test_method}}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性三" :name=2>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="适用密度范围：" prop="productDetail_density_range" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_density_range}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="稳泡能力：" prop="productDetail_stabilizing_porency" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_stabilizing_porency}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="泡孔结构：" prop="productDetail_cell_structure" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_cell_structure}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="加工宽容度：" prop="productDetail_processing_latitude" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_processing_latitude}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="低挥发：" prop="productDetail_low_VOC" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_low_VOC}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="水解稳定性：" prop="productDetail_sensitive_to_hydrolysis" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_sensitive_to_hydrolysis}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="阻燃性能：" prop="ProductDetail_FR_property" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.ProductDetail_FR_property}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="低挥发：" prop="productDetail_low_VOC" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_low_VOC}}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性四" :name=3>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="炼油 Banner （异构）：" prop="productDetail_refinery_banner" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_refinery_banner}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="炼油 Inovyn（异构）" prop="productDetail_refinery_inovyn" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_refinery_banner}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="炼油 AGC(I grade)（重整）：" prop="productDetail_refinery_AGC" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_refinery_AGC}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清洗 AGC(S grade)：" prop="productDetail_washing_AGC_S" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_washing_AGC_S}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清洗 AGC(M grade)：" prop="productDetail_washing_AGC_M" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_washing_AGC_M}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="制冷 AGC(S grade)：" prop="productDetail_washing_AGC_Cooling_S" :label-width="formTypeNumberLabelTypeWidth">
                                    <div>{{formProduct.productDetail_washing_AGC_Cooling_S}}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs> -->
            </el-form>
            <div class="dialog-footer">
                <el-button @click="closedDialog">返 回</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api/api'
import cxf from '@/utils/GeneralFn'
    export default {
        name: "detialProductDialog",
        components: {
         },
        data() {
            return {
                mType:cxf.getMainType(),
                sType:[],
                productFile:[],
                status:cxf.getProductStatus(),
                lang:cxf.getProductLang(),
                dialogFormVisible:false,
                formLabelWidth:100,
                formTypeNumberLabelTypeWidth:200,
                formProduct: {
                    attchs: [],
                    typeNumberName:1,
                    lang:""
                },
                formProductRules:{
                    ProductDetail_mtype: [
                        { required: true, message: 'Please input main type', trigger: 'blur' },
                    ],
                    ProductDetail_stype: [
                        { required: true, message: 'Please input sub type', trigger: 'blur' },
                    ]
                },
                tempPicUrl:[]
            }
        },
        props:{
            isDetialProductShow:Boolean,
            currentProductDetial:Object,
            timekey:Number
        },
        created(){
        },
        methods:{
            closedDialog(){
                this.dialogFormVisible = false;
                this.$emit('hanldeCurrentPage', {
                    'mType': cxf.getMainTypeValue(this.formProduct.productDetail_mtype),
                    'sType': cxf.getSubTypeValue(cxf.getMainTypeValue(this.formProduct.productDetail_mtype), this.formProduct.productDetail_stype)
                });
            },
            submitForm(){
                this.$refs['formProduct'].validate(( valid ) => {
                    if (valid) {
                        let _addFromData = new FormData();
                        const data = this.formProduct;
                        _addFromData.append("apiType", "fromData");
                        for (let item in data) {
                            if ( item === 'attchs') {
                                for (let d in this.productFile) {
                                    if (this.productFile.length !== 0 ) {
                                        _addFromData.append('file', this.productFile[d] );
                                    }
                                }
                            } else {
                                if ( data[item] ) {
                                    switch ( item ) {
                                        case 'productDetail_mtype' : 
                                            _addFromData.append(item, typeof data[item] === 'number' ? data[item] : cxf.getMainTypeValue(data[item]));
                                            break;
                                        case 'productDetail_stype' : 
                                            var isMtype = typeof data['productDetail_mtype'] === 'number';
                                            var isStype = typeof data['productDetail_stype'] === 'number';
                                            var _tempMtype = "";
                                            var _tempStype = "";

                                            _tempMtype = isMtype ? data['productDetail_mtype'] : cxf.getMainTypeValue(data['productDetail_mtype']);
                                            _tempStype = isStype ? data['productDetail_stype'] : cxf.getSubTypeValue( _tempMtype , data['productDetail_stype']);
                                            _addFromData.append(item, _tempStype);
                                            break;
                                        case 'productDetail_status' : 
                                            _addFromData.append(item, typeof data[item] === 'number' ? data[item] : cxf.getProductStatusValue(data[item]));
                                            break;
                                        default:
                                            _addFromData.append(item, data[item]);
                                            break;
                                    }
                                }
                            }
                        }

                        api.postEditProduct( _addFromData ).then( res => {
                            if ( res.data.success) {
                                this.$message({
                                    message: '产品修改成功！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.dialogFormVisible = false;
                            this.$refs['formProduct'].resetFields();
                            this.$emit('hanldeCurrentPage');
                        }).catch( () => {
                            this.$message({
                                message: '产品修改出错，请联系相关员！',
                                type: 'errow'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            async handleAvatarSuccess( n ,file) {
                const _addFromData = new FormData();
                _addFromData.append("apiType", "fromData");
                _addFromData.append("file", file.raw)

                let _resImage = await api.postUploadImage( _addFromData );
                
                if ( _resImage.data.success ) {
                    let imageId = _resImage.data.data;
                    this.formProduct.attchs.push(imageId);
                    this.productFile.push(file.raw)
                    let _resimageUrl = await api.getSysFileInfoPreview( { id:imageId } );
                    if ( _resimageUrl.status ) {
                        this.tempPicUrl.push(window.URL.createObjectURL(new Blob([_resimageUrl.data])));
                    }
                } else {
                    this.$message({
                        message: '图片录入出错，请联系相关员！',
                        type: 'errow'
                    })
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            handleSubType( mid ) {
                this.sType = cxf.getSubType( mid );
            },
            async getImage( id ) {
                if (id) {
                    let _tempRes = await api.getSysFileInfoPreview({id: id});
                        if ( _tempRes.status === 200 ) {
                            this.productFile.push(new Blob([_tempRes.data]));
                            this.tempPicUrl.push(window.URL.createObjectURL(new Blob([_tempRes.data])));
                        } else {
                            return '--';
                        }
                } else {
                    return "无图片"
                }
                
            }
        },
        watch:{
            isDetialProductShow( newv ){
                this.dialogFormVisible = newv;
            },
            timekey( newv, oldv ){
                if (newv !== oldv && oldv !== "")
                this.dialogFormVisible = this.$props.isDetialProductShow;
            },
            currentProductDetial ( newv ) {
                this.formProduct = newv;
                this.tempPicUrl = [];
                this.productFile = [];
                let tempmType = typeof this.formProduct['productDetail_mtype'] === 'number' ? this.formProduct['productDetail_mtype'] : cxf.getMainTypeValue(this.formProduct['productDetail_mtype']);
                this.sType = cxf.getSubType( tempmType );
                
                this.formProduct.attchs.forEach( async item => {
                    await this.getImage( item );
                });
            }
        }
    }
</script>


<style scoped>
.avatar-uploader span,i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 15px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  
.dialog-footer {
    padding-top:20px;
}

.el-tabs__content{
    height: 200px !important;
}
</style>